// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"50c779b0","31":"45ca14bf","93":"38e7ebf2","162":"d7d4b750","224":"efb60492","243":"63042fcb","706":"d6563b5e","787":"9232aa5a","900":"7d5aebfb"}[chunkId] + ".chunk.js";
};